jQuery(document).ready(function($) {
  var cleanBaseUrl = object_name.baseUrl.replace(/\/wp-usd\/?$/, '');
  var templateUrl = object_name.templateUrl;
  var siteplanColors = object_name.siteplanColors;
  var isAdmin = object_name.isAdmin;

  console.log('Clean baseUrl:', cleanBaseUrl); // Debugging line to ensure baseUrl is correct

  if ($('#mapplic').length > 0) {
    var plotLoaderDelay;
    var sitePlan;

    if ($('.template--clean').length > 0) {
      const dataWidth = $('#section-siteplan').attr('data-siteplan-width');
      const dataHeight = $('#section-siteplan').attr('data-siteplan-height');
      let siteplanWidth = dataWidth > 0 ? dataWidth : 1200;
      let siteplanHeight = dataHeight > 0 ? dataHeight : 846;

      sitePlan = $('#mapplic').mapplic({
        source: cleanBaseUrl +
                '/wp-json/siteplan-json/v1/dev/' +
                $('#section-siteplan').attr('data-dev') +
                '?v=' +
                $.now(),
        sidebar: false, 
        minimap: false,
        markers: false, 
        search: false,
        fillcolor: false,
        fullscreen: true,
        maxscale: 3,
        developer: false,
        width: siteplanWidth,
        height: siteplanHeight,
        mousewheel: false,
        deeplinking: false,
      });
    } else {
      if (isAdmin || location.hostname === 'localhost') {
        sitePlan = $('#mapplic').mapplic({
          source: cleanBaseUrl +
                  '/wp-json/siteplan-json/v1/dev/' +
                  $('#section-siteplan').attr('data-dev') +
                  '?v=' +
                  $.now(),
          sidebar: false,
          minimap: false,
          markers: false,
          search: false,
          fillcolor: false,
          fullscreen: false,
          maxscale: 3,
          developer: true,
          height: 600,
          mousewheel: false,
          deeplinking: false,
        });

        let clickedPlotNumber = 0;
        let output = [];

        $('#mapplic').on('mouseup', function(event) {
          if (event.which === 2) {
            clickedPlotNumber++;
            let x = $('.mapplic-coordinates-x').html();
            let y = $('.mapplic-coordinates-y').html();
            let item = ['Plot ' + clickedPlotNumber, x, y];
            output.push(item);
            console.table(output);
          }
        });
      } else {
        sitePlan = $('#mapplic').mapplic({
          source: cleanBaseUrl +
                  '/wp-json/siteplan-json/v1/dev/' +
                  $('#section-siteplan').attr('data-dev') +
                  '?v=' +
                  $.now(),
          sidebar: false,
          minimap: false,
          markers: false,
          search: false,
          fillcolor: false,
          fullscreen: false,
          maxscale: 3,
          developer: false,
          height: 600,
          mousewheel: false,
          deeplinking: false,
        });
      }
    }

    sitePlan.on('mapready', function(e, self) {
      var svgElement = $('.mapplic-map-image>svg')[0];
      var svgPlots = $('#landmarks-plots>*');
      if (svgPlots.length === 0) svgPlots = $('#landmark-plots>*');

      svgPlots.each(function() {
        var plotId = this.id.split('-')[1];
        var plotClassList = this.className.baseVal.split(' ');

        $.each(plotClassList, function() {
          var circleColor = '';
          if (this.indexOf('status__') >= 0) {
            var plotAvailability = this.split('__')[1];
            circleColor = siteplanColors[plotAvailability];
          } else {
            circleColor = siteplanColors['coming_soon'];
          }
          $('#status-' + plotId).css('fill', circleColor);
        });
      });
    });

    sitePlan.on('mapready', function(e, self) {
      if ($('.section__site-plan--plot')) {
        var plotNumber = $('#section-siteplan').attr('data-plot-number');
        var plotId = 'land-' + plotNumber;

        plotLoaderDelay = setTimeout(function() {
          self.showLocation(plotId);
        }, 1000);
      }
    });

    sitePlan.on('locationopened', function(e, location) {
      if ($('.template--clean').length > 0) {
        sitePlan.find('a').attr('target', '_blank');
      }
      clearTimeout(plotLoaderDelay);
    });
  }
});
